import { useCallback } from 'react';

import { snackbar } from '@occc-app/design-system';
import { Offer_Engagement_Type } from '@occc/graphql';

import { CopyOffer, useCopyOffer } from './useCopyOffer';

export const useCopyCampaignComponent = (): CopyOffer => {
  const copyOffer = useCopyOffer();

  const copyCampaignComponent: CopyOffer = useCallback(
    async (props) => {
      const { offer } = props;

      if (!offer.earningMechanism && offer.engagementType !== Offer_Engagement_Type.Billboard) {
        /* eslint-disable quotes*/
        snackbar.error(
          "This component cannot be copied because it doesn't have an earning mechanism configured",
        );

        return;
      }

      return await copyOffer(props);
    },
    [copyOffer],
  );

  return copyCampaignComponent;
};
